import React from "react";
import { useTranslation } from "react-i18next";
import JsonData from "../../data/data.json";

export function LegalContentRenderer({ sections }) {
  const contact = JsonData?.Contact || {};
  const about = JsonData?.About || {};

  const vars = {
    nameBank: about.nameBank || contact.nameBank || "CIRYON",
    nameBank2: about.nameBank2 || contact.nameBank2 || "CIRYON",
    nameDomain: about.nameBankDomain || contact.nameBankDomain || "ciryon",
    bankDomain: about.nameBankDomain || contact.nameBankDomain || "ciryon",
    brand: about.nameBank || contact.nameBank || "CIRYON",
    cnpj: contact.line1?.cnpj || "",
    address: contact.line1?.address || "",
    complement: contact.line1?.complemento || "",
    district: contact.line1?.bairro || "",
    city: contact.line1?.city || "",
    zip: contact.line1?.cep || "",
    email: contact.email || "",
  };

  const interpolate = (text) =>
    String(text).replace(/\{\{(\w+)\}\}/g, (_, key) => {
      const value = vars[key];
      return value != null ? String(value) : `{{${key}}}`;
    });

  if (!Array.isArray(sections)) return null;

  return (
    <div id="bodyContrato" className="inner-page__card inner-page__prose text-just">
      {sections.map((section, index) => {
        if (section.type === "heading") {
          const Tag = `h${section.level || 5}`;
          return React.createElement(Tag, { key: index }, interpolate(section.text));
        }

        if (section.type === "list") {
          return (
            <ul key={index}>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} dangerouslySetInnerHTML={{ __html: interpolate(item) }} />
              ))}
            </ul>
          );
        }

        if (section.type === "html") {
          return (
            <p
              key={index}
              dangerouslySetInnerHTML={{ __html: interpolate(section.text) }}
            />
          );
        }

        return <p key={index}>{interpolate(section.text)}</p>;
      })}
    </div>
  );
}

export function useLegalSections(namespace) {
  const { t } = useTranslation(namespace);
  return t("sections", { returnObjects: true });
}
